import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchShareDelete, fetchShareMeterList, selectManagerArea } from '@/api/PMS/baseInformation/meterManager';
import { fetchList as getMeterTypeList } from '@/api/PMS/baseInformation/meterType';
import waves from '@/directive/waves'; // 水波纹指令

import instrumentAdd from './add';
import changeMeter from './changeMeter';
export default {
  components: {
    instrumentAdd: instrumentAdd,
    changeMeter: changeMeter
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        meterName: ''
      },
      title: '',
      meterId: '',
      multipleSelection: [],
      meterTypeList: [],
      areaList: [],
      dialogChangeVIsible: false,
      dialogFormVisible: false
    };
  },
  created: function created() {
    this.loadAreaList();
    this.getList();
    this.loadMeterTypeList();
  },
  methods: {
    loadMeterTypeList: function loadMeterTypeList() {
      var _this = this;

      getMeterTypeList({}).then(function (r) {
        _this.meterTypeList = r.data.data;
      });
    },
    loadAreaList: function loadAreaList() {
      var _this2 = this;

      selectManagerArea({}).then(function (r) {
        _this2.areaList = r.data.data;
      });
    },
    // 小区名称变更
    areaChange: function areaChange() {
      // 清理房间id,楼栋id
      if (this.listQuery.areaGroupId) {
        delete this.listQuery.areaGroupId;
      }

      this.groupList = [];

      if (this.listQuery.areaId) {}
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    },
    handCancleChange: function handCancleChange(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogChangeVIsible = false;
    },
    handCancleList: function handCancleList(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogListVIsible = false;
    },
    getList: function getList() {
      var _this3 = this;

      this.listLoading = true;
      fetchShareMeterList(this.listQuery).then(function (response) {
        _this3.list = response.data.data;
        _this3.total = response.data.total;
        _this3.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.meterId = '';
      this.title = '添加';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(meterId) {
      this.meterId = meterId;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    handleChangeMeter: function handleChangeMeter(meterId) {
      this.meterId = meterId;
      this.title = '换表';
      this.dialogChangeVIsible = true;
    },
    delete: function _delete(meterIds) {
      var _this4 = this;

      if (meterIds.length > 0) {
        this.$confirm('你确定是要删除这些仪表, 是否继续?', '提示').then(function () {
          fetchShareDelete({
            ids: meterIds
          }).then(function (response) {
            if (response.data.code === 200) {
              _this4.getList();

              _this4.Alert({
                alertType: 'delete'
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(meterId) {
      var meterIds = [];
      meterIds.push(meterId);
      this.delete(meterIds);
    },
    handleDeletes: function handleDeletes() {
      var meterIds = [];
      this.multipleSelection.forEach(function (row) {
        meterIds.push(row.shareMeterId);
      });
      this.delete(meterIds);
    }
  }
};